import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const MAX_EMAIL_LENGTH = 254;
export const emailValidator = ({ requiredError, formatError, }) => z
    .email({
    error: createErrorHandler(requiredError, formatError),
})
    .superRefine((val, ctx) => {
    const result = z
        .string()
        .max(MAX_EMAIL_LENGTH, { error: formatError })
        .safeParse(val);
    if (result.success) {
        return;
    }
    // This prevents displaying the same format error when
    // email is too long and with invalid format
    ctx.addIssue({ ...result.error.issues[0] });
});
